import { Divider, Stack } from '@mui/material'
import type { FC } from 'react'
import type { DockCategoryKey } from '../../utils/widgetsByCategory'
import { useLicensedSections } from '../../../../hooks/useLicensedWidgets'
import { DOCK_CATEGORIES_TYPES } from '../../../../types/dockTypes'
import { CattlesContainer } from '../cattles-container'
import { FeedTableContainer } from '../food-table-container'
import { HealthTableContainer } from '../health-container'
import { MilkYieldTableContainer } from '../milk-yield-container'
import { MilkingRoutineTableContainer } from '../milking-routine-container'

const SECTION_COMPONENTS: Record<DockCategoryKey, FC> = {
	[DOCK_CATEGORIES_TYPES.CATTLES]: CattlesContainer,
	[DOCK_CATEGORIES_TYPES.FOOD_TABLE]: FeedTableContainer,
	[DOCK_CATEGORIES_TYPES.HEALTH]: HealthTableContainer,
	[DOCK_CATEGORIES_TYPES.MILKING_PROCESS]: MilkingRoutineTableContainer,
	[DOCK_CATEGORIES_TYPES.MILK_YIELD]: MilkYieldTableContainer,
}

export const AllWidgetsContainer = () => {
	const sectionsWithLicense = useLicensedSections()

	if (sectionsWithLicense.length === 0) return null

	return (
		<Stack direction='column' gap='16px' paddingRight='24px'>
			{sectionsWithLicense.flatMap(({ key }, index) => {
				const Component = SECTION_COMPONENTS[key]
				return index === 0
					? [<Component key={key} />]
					: [<Divider key={`divider-${key}`} />, <Component key={key} />]
			})}
		</Stack>
	)
}
